<template>
  <van-popup v-model="popupShow" round position="bottom">
    <van-cascader v-model="countyId" title="请选择所在地区" :options="options" @finish="finish" :field-names="fieldNames"
      @close="popupShow = false"  @change="change"/>
  </van-popup>
</template>

<script>
import baseApi from '@/api/base'
export default {
  components: {},
  data () {
    return {
      popupShow: false,
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'child'
      },
      options: [],
      provinceId: '',
      cityId: '',
      countyId: '',
      location: ''
    }
  },
  computed: {},
  created () {
    // this.getDistrictList()
  },
  methods: {
    getDistrictList () {
      baseApi.getDistrictList().then(res => {
        if (res.data.resultCode === '0') {
          this.options = res.data.resultData.data
          if (this.addressId && this.options && this.options.length) {
            let province = this.options.find(item => {
              return item.id === this.provinceId
            })
            let city = province.child.find(item => {
              return item.id === this.cityId
            })
            let county = city.child.find(item => {
              return item.id === this.countyId
            })
            this.location = province.name + city.name + county.name
          }
        }
      })
    },
    finish (value) {
      // this.provinceId = value.selectedOptions[0].id
      // this.cityId = value.selectedOptions[1].id
      // this.countyId = value.selectedOptions[2].id
      // this.location = value.selectedOptions[0].name + value.selectedOptions[1].name + value.selectedOptions[2].name
      this.popupShow = false
    },
    open (provinceId, cityId, countyId) {
      this.provinceId = provinceId
      this.cityId = cityId
      this.countyId = countyId
      this.getDistrictList()
      this.popupShow = true
    },
    close () {
      this.popupShow = false
    },
    change (data) {
      const { selectedOptions, tabIndex } = data
      let hasCounty = false
      switch (tabIndex) {
        case 0:
          this.provinceId = selectedOptions[0].id
          this.cityId = ''
          this.location = selectedOptions[0].name
          hasCounty = false
          break
        case 1:
          this.cityId = selectedOptions[1].id
          hasCounty = false
          this.location = selectedOptions[0].name + selectedOptions[1].name || ''
          break
        case 2:
          this.countyId = selectedOptions[2].id
          hasCounty = true
          const provinceCityName = selectedOptions[0].name + selectedOptions[1].name
          this.location = provinceCityName + selectedOptions[2].name || ''
          break
        default:
          break
      }
      this.$emit('setLocation', {
        provinceId: this.provinceId,
        cityId: this.cityId,
        location: this.location,
        countyId: hasCounty ? this.countyId : ''

      })
    }
  }
}
</script>
<style scoped lang="less">
.van-cascader /deep/ .van-tabs__content {
  min-height: auto;
}
</style>
